import { useEffect, useRef } from 'react';
import {
  gridClasses,
  gridColumnMenuSelector,
  GridPanel as MuiGridPanel,
  GridPanelProps,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

// DataGrid anchors the filter panel to the grid's top-left corner; anchor it to the column header that opened it instead.
export const GridPanel = (props: GridPanelProps & { 'aria-labelledby'?: string }) => {
  const apiRef = useGridApiContext();
  const columnMenu = useGridSelector(apiRef, gridColumnMenuSelector);
  const lastMenuField = useRef<string | null>(null);

  useEffect(() => {
    if (columnMenu.open && columnMenu.field) lastMenuField.current = columnMenu.field;
  }, [columnMenu]);

  const resolveAnchor = () => {
    if (props.anchorEl || !props.open) return props.anchorEl;
    const labelId = props['aria-labelledby'];
    const root = apiRef.current.rootElementRef?.current;
    return (
      (labelId ? document.getElementById(labelId) : null) ??
      (lastMenuField.current
        ? root?.querySelector(`.${gridClasses.columnHeader}[data-field="${lastMenuField.current}"]`)
        : null) ??
      undefined
    );
  };

  return <MuiGridPanel {...props} anchorEl={resolveAnchor()} />;
};
